import { gql } from 'graphql-request'

export const UPDATE_MAIN_MENU = gql`
  mutation UpdateMainMenu($updateMainMenuInput: UpdateMainMenuInput!) {
    updateMainMenu(updateMainMenuInput: $updateMainMenuInput) {
      id
    }
  }
`
